import  cloneDeep from 'lodash.clonedeep';

export const deepClone = cloneDeep;